var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMirExternalchat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.02007 12.2807C4.02007 14.6796 4.76073 15.8688 5.82968 17.4695C5.7592 17.519 4.18432 19.055 4.10091 19.227C3.78805 19.8659 4.24168 20.583 4.92497 20.583H12.3436C15.8795 20.583 19.1884 18.1528 20.1818 14.8436C20.3304 14.343 20.5078 13.8892 20.0984 13.4669C19.6838 13.0366 18.7321 13.0133 18.4817 13.9806C17.8714 16.3326 16.0176 18.0014 13.6681 18.5753C12.6146 18.8308 8.44249 18.7292 7.17816 18.7292C7.42328 18.364 8.50538 17.827 7.76492 16.8829C7.02427 16.0042 6.51326 15.5348 6.10646 14.106C4.99303 10.2103 7.70482 6.3274 11.4179 5.9232C12.0698 5.85273 12.5391 5.92575 12.9224 5.61817C13.2797 5.33135 13.371 4.54647 12.7868 4.15803C12.0306 3.65211 9.25349 4.47089 8.26262 5.06805C5.63148 6.65351 4.02001 9.175 4.02001 12.2806L4.02007 12.2807Z",
    fill: "#CAD1CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.88 7.29L14.71 9.46C14.3179 9.85212 14.3179 10.4879 14.71 10.88C15.1021 11.2721 15.7379 11.2721 16.13 10.88L18.3 8.71L19.74 10.15C20.05 10.46 20.59 10.24 20.59 9.79V5.5C20.59 5.22 20.37 5 20.09 5H15.8C15.35 5 15.13 5.54 15.44 5.85L16.88 7.29Z",
    fill: "#CAD1CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMirExternalchat);
export default __webpack_public_path__ + "static/media/mir_externalchat.9845b63640a725bdc228ea2a5a18da4e.svg";
export { ForwardRef as ReactComponent };